'use client';

import Link from 'next/link';

const legalLinks = [
  { href: '/web/legal/imprint', label: 'Impressum' },
  { href: '/web/legal/privacy', label: 'Datenschutz' },
  { href: '/web/legal/terms', label: 'AGB' },
  { href: '/web/legal/risk-disclaimer', label: 'Risikohinweis' },
  { href: '/web/legal/refund-policy', label: 'Rückerstattung' },
  { href: '/web/legal/indicator-license', label: 'Indikator-Lizenz' },
  { href: '/web/legal/right-of-withdrawal', label: 'Widerrufsbelehrung' },
];

const productLinks = [
  { href: '/web/features', label: 'Features' },
  { href: '/web/indicator', label: 'Indicator' },
];

const resourceLinks = [
  { href: '/web/pricing', label: 'Pricing' },
  { href: '/web/brokers', label: 'Supported Brokers' },
  { href: '/web/feedback', label: 'Roadmap' },
  { href: 'mailto:Kontakt@tradeate.com', label: 'Kontakt' },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-background">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link href="/web" className="inline-block">
              <span className="text-lg font-bold bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent">
                TradeAte
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground/60">
              Das Trading-Journal für professionelle Trader.
            </p>
            <p className="mt-4 text-xs text-foreground/40">
              Moundi GmbH<br />
              Koblenz, Deutschland
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">Produkt</h3>
            <ul className="space-y-2">
              {productLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="text-sm text-foreground/60 hover:text-foreground transition"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">Ressourcen</h3>
            <ul className="space-y-2">
              {resourceLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="text-sm text-foreground/60 hover:text-foreground transition"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-4">Rechtliches</h3>
            <ul className="space-y-2">
              {legalLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="text-sm text-foreground/60 hover:text-foreground transition"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-foreground/40">
              © {currentYear} Moundi GmbH. Alle Rechte vorbehalten.
            </p>
            <div className="flex items-center gap-4">
              <Link
                href="/web/legal/privacy"
                className="text-xs text-foreground/40 hover:text-foreground/60 transition"
              >
                Datenschutz
              </Link>
              <span className="text-foreground/20">|</span>
              <Link
                href="/web/legal/terms"
                className="text-xs text-foreground/40 hover:text-foreground/60 transition"
              >
                AGB
              </Link>
              <span className="text-foreground/20">|</span>
              <Link
                href="/web/legal/imprint"
                className="text-xs text-foreground/40 hover:text-foreground/60 transition"
              >
                Impressum
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
